<template>
  <v-app id="inspire">
    <v-container fluid fill-height>
      <v-dialog v-model="cargando" hide-overlay persistent width="300">
        <v-card color="primary" dark class="loading">
          <v-card-text>
            Espere un momento
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-layout align-center justify-start @keyup="funcionTeclaEnter">
        <v-flex xs4 class="d-none d-sm-flex">
          <v-img :src="urlImage" contain></v-img>
        </v-flex>
        <v-flex xs12 sm8 md4>
          <v-card class="elevation-12">
            <v-toolbar dark color="purple">
              <v-toolbar-title>Iniciar Sesión</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-form @submit.prevent="login" @keyup="funcionTeclaEnter">
                <v-text-field
                  @keypress="soloDni"
                  @change="limpiar_msj"
                  :rules="usuario"
                  v-model="usr"
                  prepend-icon="mdi-account"
                  name="usuario"
                  label="Usuario"
                  type="text"
                ></v-text-field>
                <v-text-field
                  :rules="password"
                  v-model="passw"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show1 ? 'text' : 'password'"
                  id="password"
                  prepend-icon="mdi-lock"
                  name="contraseña"
                  label="Contraseña"
                  @click:append="show1 = !show1"
                ></v-text-field>
              </v-form>
              <div class="text-center msjError">{{ msj }}</div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" :disabled="cargando" @click="login"
                >Iniciar Sesión</v-btn
              >
            </v-card-actions>
            <v-layout>
              <v-flex class="text-center" pa-6>
                <a @click="restablecer_password">Olvide mi Contraseña</a>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
      <v-footer fixed>
        <v-card class="flex" flat tile>
          <v-card-text class="text-center">
            Sistema de Alumnos
            <strong>V2.0</strong>
          </v-card-text>
        </v-card>
      </v-footer>
    </v-container>
  </v-app>
</template>

<script>
import API from "@/components/_config/conf";
//import axios from "axios";

export default {
  data: () => ({
    //msj: "Usuario y/o Contraseña incorrectos."
    cargando: false,
    urlImage: require("../assets/imgs/logoLogin_" +
      process.env.VUE_APP_EPA +
      ".png"),
    usr: "",
    passw: "",
    show1: false,
    usuario: [(v) => !!v || "Usuario es obligatorio"],
    password: [(v) => !!v || "Contraseña es obligatorio"],
    msj: "",
    mostrarMsj: false,
    email: "",
    restablecer_pass: false,
    msj_restablecer: "",
    emailReglas: [
      (v) => !!v || "E-mail es obligatorio",
      (v) => /.+@.+/.test(v) || "Debe ingresar un E-mail valido",
    ],
  }),
  props: {
    //source: String
  },
  methods: {
    funcionTeclaEnter(event) {
      if (event.keyCode == 13) this.login();
    },
    soloDni(e) {
      API.soloNumeros(e);
    },
    limpiar_msj: function () {
      this.msj = "";
    },
    login: function () {
      this.msj = "";
      this.cargando = true;
      if (this.usr != "" && this.passw != "") {
        let param = "usuario=" + this.usr + "&password=" + this.passw;
        let resultado = API.enviar("get", "login", param);

        resultado
          .then((result) => {
            if (result.data.msj != "ok") this.msj = result.data.msj;
            else {
              //document.location.href = "/#/main"
              this.guardarLocalStorage(result.data);
              //console.log(result.data.idCategoria);
              API.PERMISO = result.data.idCategoria;
            }
          })
          .catch(() => {
            document.location.href = "/mensaje";
          })
          .finally(() => {
            this.cargando = false;
          });
      } else this.msj = "Debe ingresar Usuario y Contraseña !";
    },
    guardarLocalStorage: function (datosUsuario) {
      window.localStorage.setItem("EPA_AUTH", JSON.stringify(datosUsuario));
      document.location.href = "/main";
    },
    restablecer_password: function () {
      this.email = "";
      this.restablecer_pass = true;
      console.log("restablecer_password");
    },
    enviar_mail: function () {
      if (this.email != "") {
        let param = "email=" + this.email;
        let resultado = API.enviar("get", "restablecerPassword", param);
        resultado.then((result) => {
          console.log("restablecer contraseña  then: -> " + result.data.msj);

          if (result.data.msj != "ok")
            this.msj_restablecer = result.data.result;
        });
      }

      console.log("enviar_mail");
    },
  },
};
</script>

<style scoped>
.msjError {
  color: red;
}
</style>
